package com.arena_web.ui.sections.profile.mobile

import androidx.compose.runtime.Composable
import com.arena_web.data.dto.UserCardDto
import com.arena_web.data.dto.UserStoryDto
import com.arena_web.ui.components.overlay.BottomSheet
import com.arena_web.ui.components.overlay.StoryViewerContent

/**
 * Mobile story-viewer bottom sheet — Figma 8682:456159. The phone counterpart
 * to the desktop [com.arena_web.ui.components.overlay.StoryViewerModal]: the
 * same auto-advancing story body ([StoryViewerContent]) lifted into the shared
 * [BottomSheet] (drag handle, swipe-to-dismiss, scrim). Opened by tapping a
 * story circle in the mobile profile Player Hub.
 *
 * The body hides its in-header close disc (`showClose = false`) since the sheet
 * already dismisses via drag / scrim; `contentGap = 24` matches the Figma stack
 * (handle → progress + identity → image → counters).
 */
@Composable
fun MobileStoryViewerSheet(
    stories: List<UserStoryDto>,
    initialIndex: Int,
    title: String,
    sportName: String,
    activeCard: UserCardDto?,
    avatarUrl: String?,
    onDismiss: () -> Unit,
    onLikeClick: ((storyId: String) -> Unit)? = null,
    // Tapping "Seen by" reports the current story id so the caller can pop the
    // viewers sheet over this one; [externallyPaused] holds auto-advance while
    // that sheet is open.
    onSeenByClick: ((storyId: String) -> Unit)? = null,
    externallyPaused: Boolean = false,
) {
    if (stories.isEmpty()) return
    BottomSheet(onDismiss = onDismiss, contentGap = 24) {
        StoryViewerContent(
            stories = stories,
            initialIndex = initialIndex,
            title = title,
            sportName = sportName,
            activeCard = activeCard,
            avatarUrl = avatarUrl,
            onDismiss = onDismiss,
            onLikeClick = onLikeClick,
            showClose = false,
            onSeenByClick = onSeenByClick,
            externallyPaused = externallyPaused,
        )
    }
}
